var map = {
	"./acorn.png": 8825,
	"./banana.png": 2906,
	"./bell.png": 4231,
	"./boomerang.png": 8455,
	"./cherry.png": 8557,
	"./crossing.png": 2200,
	"./egg.png": 5456,
	"./feather.png": 5646,
	"./flower.png": 2605,
	"./fruit.png": 5143,
	"./golden_dash.png": 9182,
	"./leaf.png": 7772,
	"./lightning.png": 4327,
	"./lucky_cat.png": 513,
	"./moon.png": 5626,
	"./mushroom.png": 325,
	"./propeller.png": 9308,
	"./rock.png": 6452,
	"./shell.png": 6005,
	"./special.png": 5847,
	"./spiny.png": 9398,
	"./star.png": 4551,
	"./triforce.png": 5805,
	"./turnip.png": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3919;